import React, { useEffect } from "react";
import SignIn from "../components/SignIn";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

const Signin = () => {
    const { user } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (user) {
            navigate("/profile");
        }
    });
    return (
        <div>
            <SignIn />
        </div>
    );
};

export default Signin;
